import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'intersection-observer'

import { React, ReactDOM } from '@/vendor'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
